import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Progress, Card, Button } from 'antd';
import { useHistory } from 'react-router-dom';

import { LayoutGrid } from 'components/layouts';
import { ROUTE_WORKER_PREFIX } from 'utils/routes';

const progressWidth = 80;

const getDBSStaus = (isRegistered, isDBSFinish) => {
  if (isRegistered === false) return 'exception';
  if (isDBSFinish) return 'success';
  return 'normal';
};

const getRegistrationAlert = (isDBSFinish, isProfileFinish, isShiftsFinish) => {
  if (!isDBSFinish)
    return 'You need to fill your DBS information before you can continue';
  if (!isProfileFinish)
    return 'You need to complete your profile before you can continue';
  if (!isShiftsFinish)
    return 'You need to fill your shifts availability before you can continue';
  return null;
};

const ProfileStepsWidget = ({
  isRegistered,
  profilePercentage,
  dbsPercentage,
  shiftsPercentage,
}) => {
  const history = useHistory();

  const isProfileFinish = profilePercentage === 100;
  const isDBSFinish = dbsPercentage === 100;
  const isShiftsFinish = shiftsPercentage === 100;

  const dbsStatus = getDBSStaus(isRegistered, isDBSFinish);
  const alertText = getRegistrationAlert(
    isProfileFinish,
    isDBSFinish,
    isShiftsFinish
  );

  return (
    <>
      {alertText ? (
        <Alert description={alertText} type="info" showIcon />
      ) : null}
      <LayoutGrid>
        <Card
          title="Make sure your DBS is up to date"
          headStyle={{ textAlign: 'center' }}
        >
          <Progress
            type="circle"
            status={dbsStatus}
            percent={dbsPercentage}
            width={progressWidth}
          />
          <Button
            type="primary"
            onClick={() => {
              history.push(`${ROUTE_WORKER_PREFIX}/dbs-check`);
            }}
          >
            Update
          </Button>
        </Card>
        <Card
          title="Complete your profile"
          disabled={!isDBSFinish}
          headStyle={{ textAlign: 'center' }}
        >
          <Progress
            type="circle"
            percent={profilePercentage}
            width={progressWidth}
          />
          <Button
            disabled={!isDBSFinish}
            type="primary"
            onClick={() => {
              history.push(`/update-profile`);
            }}
          >
            Update
          </Button>
        </Card>
        <Card
          title="Select shift times and rate of pay"
          headStyle={{ textAlign: 'center' }}
        >
          <Progress
            type="circle"
            percent={shiftsPercentage}
            width={progressWidth}
          />
          <Button
            type="primary"
            disabled={!isDBSFinish || !isProfileFinish}
            onClick={() => {
              history.push(`${ROUTE_WORKER_PREFIX}/shifts-info`);
            }}
          >
            Update
          </Button>
        </Card>
      </LayoutGrid>
    </>
  );
};

ProfileStepsWidget.propTypes = {
  isRegistered: PropTypes.bool.isRequired,
  profilePercentage: PropTypes.number.isRequired,
  dbsPercentage: PropTypes.number.isRequired,
  shiftsPercentage: PropTypes.number.isRequired,
};

export default ProfileStepsWidget;
